"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewsletterDialog = require("./NewsletterDialog");
Object.keys(_NewsletterDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsletterDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsletterDialog[key];
    }
  });
});
var _PrivacyPolicy = require("./PrivacyPolicy");
Object.keys(_PrivacyPolicy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PrivacyPolicy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PrivacyPolicy[key];
    }
  });
});